import React, { useEffect, useState } from 'react'
import { Box, Typography, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Button, Divider, Tooltip, IconButton } from '@mui/material'
import upload from '../../assets/Project_Images/Icons/upload.png'
import info from '../../assets/Project_Images/Icons/info.png'
import { CancelOutlined } from '@mui/icons-material'
import { styled } from '@mui/material/styles';
import { useFormik } from 'formik'
import * as Yup from "yup"
import { ApiGetDigisigner, ApiGetSignedStatement, ApiuploadDocuments } from '../../apiService/Core/Apicall.tsx';
import { ApisendApplication2 } from '../../apiService/Core/Apicall.tsx';
import Loading from '../Loader/Loading.tsx';
import { useDispatch, useSelector } from 'react-redux';
import { hideLoading, showLoading } from '../../Redux/loadingSlice.tsx';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'

const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: '50%',
    borderWidth: '5px',
    width: 22,
    height: 22,
    borderColor: 'green',
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    // backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
        outline: '2px auto #ADB792',
        outlineOffset: 2,
    },

}));
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#ADB792',
    backgroundImage: 'linear-gradient(180deg,hsla(0,100%,0%,.1),hsla(0,100%,0%,0))',
    '&::before': {
        display: 'block',
        width: 22,
        height: 22,
        backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        content: '""',
    },

});

// Inspired by blueprintjs
function BpRadio(props: any) {
    return (
        <Radio
            disableRipple
            color="default"
            checkedIcon={<BpCheckedIcon />}
            icon={<BpIcon />}
            {...props}
        />
    );
}

interface FormValues {
    bankName: string;
    bic: string;
    accountNo: string;
    abn: string;
    ABNNumber: string;
    statement_by_supplier: string

}

function Applicationform2() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const loading = useSelector((state: any) => state.loader.isLoading);
    const userData = JSON.parse(localStorage.getItem('userData') || '{}'); // Parse JSON
    const userOtherData = JSON.parse(localStorage.getItem('userOthreData') || '{}'); // Parse JSON
    const userId = Number(userData.userId) || 0;
    const [showerror, setshowerror] = useState<boolean>(false);
    const [isCreate, setisCreate] = useState<boolean>(userOtherData?.statementOfsupplier ? false : true);
    const documentId = localStorage.getItem('documentId') || ''
    const savedData = localStorage.getItem("bankFormData");


    const initialValues: FormValues = savedData ?
        JSON.parse(savedData) :
        {
            bankName: '',
            bic: '',
            accountNo: '',
            abn: userOtherData?.isProceedWithStatementOfSupplier ? "isProceedWithStatementOfsupplier" : userOtherData?.isProceedWithABN ? "isProceedWithABN" : '',
            ABNNumber: '',
            statement_by_supplier: (userOtherData?.isProceedWithStatementOfSupplier && userOtherData?.statementOfsupplier) ? userOtherData?.statementOfsupplier : '',
        }
    const keyup = (e: any) => {
        if (e.code === "Enter") {
            formik.handleSubmit();
        }
    };

    const validateABN = (abn: string | undefined) => {
        if (!abn) return false;

        // Remove spaces
        abn = abn.replace(/\s/g, '');

        // Must be 11 digits
        if (!/^\d{11}$/.test(abn)) return false;

        // Convert to array of numbers
        let digits = abn.split('').map(Number);

        // Subtract 1 from the first digit
        digits[0] -= 1;

        // Weighting factors
        const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

        // Calculate sum
        const sum = digits.reduce((acc, digit, index) => acc + digit * weights[index], 0);

        // Valid if sum is a multiple of 89
        return sum % 89 === 0;
    };

    const validationSchema = Yup.object({
        bankName: Yup.string().required('bankname is required'),
        bic: Yup.string().required('bsb is required'),
        // accountNo: Yup.string().length(10).required('bankname is requied'),
        accountNo: Yup.string().required('account number is required'),
        abn: Yup.string().required('Must add an ABN if you have one or select Statement by supply form then download to fill that in.'),
        ABNNumber: Yup.string().when('abn', {
            is: (val) => val === 'isProceedWithABN',
            then: (schema) =>
                schema
                    .required('Must add an ABN if you have one or select Statement by supply form then download to fill that in')
                    .test('is-valid-abn', 'Invalid ABN', (value) => validateABN(value)),
            otherwise: (schema) => schema.notRequired(),
        }),
    });
    // statement_by_supplier: Yup.string().required('bankname is requied')

    const onSubmit = async (values: FormValues) => {
        if(values?.abn === 'isProceedWithStatementOfsupplier' && !values.statement_by_supplier){
            window.alert("Please upload statement of supplier")
            return
        }
        const apiData = {
            bankName: values.bankName,
            bic: values.bic,
            accountNo: values.accountNo,
            isProceedWithStatementOfsupplier: values?.abn === 'isProceedWithStatementOfsupplier' ? true : false,
            isProceedWithABN: values?.abn === 'isProceedWithABN' ? true : false,
            ABNNumber: values.ABNNumber,
            statementOfsupplier: values.statement_by_supplier,
            userId,
            modifiedBy: userId
        }
        try {
            const response = await ApisendApplication2(apiData);
            if (response.status) {
                localStorage.removeItem('doumentId')
                localStorage.removeItem("bankFormData");
                navigate('/dashboard/dashboard');
            } else {
                // console.log('Failed to submit the form:', response);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    }
    const formik = useFormik<FormValues>({
        initialValues,
        onSubmit,
        validationSchema,
        enableReinitialize:true,
        validateOnChange: true,
        validateOnBlur: false,
    })
    const fileupload = async (filePath: any, fileType: any) => {
        const userId: any = localStorage.getItem('userId');
        const formData = new FormData();
        formData.append("userId", userId);
        formData.append("fileType", fileType);
        formData.append("file", filePath); // Add a file
        try {
            const response: any = await ApiuploadDocuments(formData);
            if (response.status) {
                // console.log(response)
                formik.setFieldValue(fileType, response.location);
            }
        }
        catch (error) {
            console.log(error)
        }
    }
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file && file.type.startsWith("image/")) {
            const imageUrl = URL.createObjectURL(file);
            fileupload(file, 'statement_by_supplier')
        } else {
            toast.error("Please upload a valid image file.");
        }
    };

    const handleApplyOnline = async () => {
        try {
            const data = {
                userId: userId,
                emailId: userData?.emailId
            }
            const res = await ApiGetDigisigner(data)
            if (res.status) {
                localStorage.setItem("documentId", (res?.data?.documents[0]?.document_id))
                localStorage.setItem(
                    "bankFormData",
                    JSON.stringify(formik.values)
                );
                window.location.href = res?.data?.documents[0]?.signers[0]?.sign_document_url;
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    }
    const handleGetSignedStatement = async () => {
        if (documentId?.length <= 0) return
        try {
            const data = `?documentId=${documentId}&userId=${userId}`

            const res = await ApiGetSignedStatement(data)
            if (res.status) {
                formik.setFieldValue('abn', "isProceedWithStatementOfsupplier")
                formik.setFieldValue('statement_by_supplier', res.data)
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    }

    useEffect(() => {
        if (documentId?.length > 0) {
            handleGetSignedStatement()
        }
    }, [])

    const isPDF = (url: string) => {
        return url?.toLowerCase().endsWith(".pdf");
    };
    console.log("Statement", formik.values.statement_by_supplier)
    return (
        <Box height='100vh' className='d-flex flex-column '>
            <form onSubmit={formik.handleSubmit}>
                <Box className='flex-grow-1'>
                    {/* ------------------------------------------------------------------------------ Header ---------------------------------------------------------- */}
                    <Box padding='20px' className='w-100 custom-bg d-flex align-items-center justify-content-between' height='72px'>
                        <Typography className='text-white fs-4 p-0 m-0'>Application form</Typography>
                        <CancelOutlined className='fs-4 text-white' />
                    </Box>


                    {/* ------------------------------------------------------------------------------------ Part-1---------------------------------------------- */}
                    <Box padding='20px'>

                        <Typography className='form-heading'>1. Bank Details</Typography>
                        <Typography className='form-heading'>Document Id {documentId}</Typography>
                        <Typography className='form-caption'>Please provide your bank detials to receive payments.</Typography>
                        <Box className='mt-2 w-100 d-flex flex-column flex-md-row gap-2'>
                            <FormControl className='col-md-4 col-12'>
                                <TextField
                                    label={
                                        <span>
                                            Bank Name{" "}
                                            <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup>
                                        </span>
                                    }

                                    InputLabelProps={{
                                        shrink: false,

                                    }}
                                    {...formik.getFieldProps("bankName")}
                                ></TextField>
                                {showerror && formik.errors.bankName ? (
                                    <Typography className="error ">
                                        {formik.errors.bankName}
                                    </Typography>
                                ) : null}
                            </FormControl>
                            <FormControl className='col-md-4 col-12'>
                                <TextField
                                    label={
                                        <span>
                                            BSB{" "}
                                            <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup>
                                        </span>
                                    }
                                    InputLabelProps={{
                                        shrink: false,

                                    }}
                                    // inputProps={{
                                    //     maxLength: 6
                                    // }}
                                    {...formik.getFieldProps("bic")}
                                ></TextField>
                                {showerror && formik.errors.bic ? (
                                    <Typography className="error ">
                                        {formik.errors.bic}
                                    </Typography>
                                ) : null}
                            </FormControl>
                            <FormControl className='flex-grow-1'>
                                <TextField
                                    label={
                                        <span>
                                            Account No.{" "}
                                            <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup>
                                        </span>
                                    }

                                    InputLabelProps={{
                                        shrink: false,

                                    }}
                                    // inputProps={{
                                    //     maxLength: 10
                                    // }}
                                    {...formik.getFieldProps("accountNo")}
                                ></TextField>
                                {showerror && formik.errors.accountNo ? (
                                    <Typography className="error ">
                                        {formik.errors.accountNo}
                                    </Typography>
                                ) : null}
                            </FormControl>

                        </Box>
                    </Box>
                    <Divider orientation='horizontal' sx={{ borderColor: '#00000033', border: '1px solid #00000033' }} />
                    {/* ------------------------------------------------------------------------------------ Part-2---------------------------------------------- */}
                    <Box padding='20px'>

                        <Typography className='form-heading'>2. Tax Details</Typography>
                        <Typography className='form-caption'>To become a mystery shopper, you need to provide an ABN or Statement by a supplier</Typography>
                        <Box className='mt-2 w-100 d-flex flex-column flex-md-row gap-2'>
                            <Box className='col-md-4 col-12'>
                                <FormControl className='mt-3'>
                                    <FormLabel id="demo-row-radio-buttons-group-label">Do you want to proceed with Statement by a supplier or ABN?{" "}   <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup></FormLabel>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        // name="row-radio-buttons-group"
                                        {...formik.getFieldProps("abn")}
                                    >
                                        <FormControlLabel value="isProceedWithStatementOfsupplier" control={<BpRadio />}
                                            label={
                                                <>
                                                    Statement by a supplier
                                                    <Tooltip className='ms-2' title="Please note that we are not a registered tax agent and are unable to provide advice regarding ABNs or Statement by a supplier. We recommend speaking directly with the ATO or a licensed tax professional for guidance." arrow>
                                                        <Box component='img' className='col-1' src={info}></Box>
                                                    </Tooltip>
                                                </>} />
                                        <FormControlLabel value="isProceedWithABN" control={<BpRadio />} label="ABN" />
                                    </RadioGroup>
                                    {showerror && formik.errors.abn ? (
                                        <Typography className="error ">
                                            {formik.errors.abn}
                                        </Typography>
                                    ) : null}
                                </FormControl>

                                {formik.values?.abn == 'isProceedWithStatementOfsupplier' && (

                                    (!formik.values.statement_by_supplier || (isCreate)) ?
                                        <Button variant='outlined' className='button-primary-outlined py-2 px-120 mt-2' onClick={() => { handleApplyOnline() }}>OPEN STATEMENT BY SUPPLY FORM</Button>
                                        :
                                        <Box className='d-flex' gap={2}>
                                            <Link target='_blank' className='custom-text' to={formik.values.statement_by_supplier}> <Button variant='outlined' className='button-primary-outlined py-2 px-120 mt-2'>Donwload Statement</Button></Link>
                                        </Box>
                                )}
                            </Box>
                            {formik.values?.abn === 'isProceedWithStatementOfsupplier' && <> <Divider orientation='vertical' sx={{ borderColor: '#00000033', height: 'auto' }} />
                                <Box className='col-md-4 col-12'>
                                    <Box className='w-100 d-flex align-items-center ms-2'>
                                        <FormControl>
                                            {!formik.values.statement_by_supplier && !documentId && <label htmlFor="file-upload" className='form-caption'>
                                                <span>
                                                    Upload the completed Statement by a supplier form{" "}
                                                    <sup>
                                                        <i className="fa-solid fa-star-of-life star"></i>
                                                    </sup>
                                                </span>

                                                <Box className='mt-2 d-flex align-items-center justify-content-center' height={140} width={335} border='1px dashed #00000033' borderRadius={5}>
                                                    <input
                                                        type="file"
                                                        id="file-upload"
                                                        accept="image/*"
                                                        style={{ display: "none" }}
                                                        onChange={handleFileChange}
                                                    />
                                                    <Box className='d-flex flex-column align-items-center justify-content-center'>
                                                        <Box component='img' height={36} width={36} src={upload}></Box>
                                                        <Typography className='form-caption'>Upload Here</Typography>
                                                    </Box>
                                                </Box>
                                            </label>
                                            }

                                            {(formik.values.statement_by_supplier || documentId) &&
                                                <>
                                                    <Box className='d-flex justify-content-end'>
                                                        <IconButton onClick={() => { formik.setFieldValue('statement_by_supplier', null) }}><CancelOutlined /></IconButton>
                                                    </Box>
                                                    {isPDF(formik.values.statement_by_supplier) ? (
                                                        <iframe
                                                            src={`${formik.values.statement_by_supplier}#toolbar=0`}
                                                            title="PDF Preview"
                                                            width="100%"
                                                            height="421px"
                                                            style={{ border: "none", borderRadius: "8px" }}
                                                        />
                                                    ) : (
                                                        <img
                                                            src={formik.values.statement_by_supplier}
                                                            alt="Uploaded preview"
                                                            width="100%"
                                                            height="100%"
                                                            style={{ objectFit: "cover", borderRadius: "8px" }}
                                                        />
                                                    )}
                                                </>
                                            }
                                        </FormControl>

                                    </Box>
                                </Box>
                            </>
                            }

                        </Box>
                        {formik.values?.abn === 'isProceedWithABN' && <FormControl className='col-md-4 col-12'>
                            <TextField
                                label={
                                    <span>
                                        ABN{" "}
                                        <sup>
                                            <i className="fa-solid fa-star-of-life star"></i>
                                        </sup>
                                    </span>
                                }
                                InputLabelProps={{
                                    shrink: false,

                                }}
                                inputProps={{
                                    maxLength: 11
                                }}

                                {...formik.getFieldProps("ABNNumber")}
                            ></TextField>

                            {showerror && formik.errors.ABNNumber ? (
                                <Typography className="error ">
                                    {formik.errors.ABNNumber}
                                </Typography>
                            ) : null}
                        </FormControl>}
                    </Box>

                </Box>
                <Box padding='0px 20px'>
                    <Divider orientation='horizontal' sx={{ borderColor: '#00000033', border: '1px solid #00000033' }} />
                    <Box className='d-flex justify-content-end'>
                        <Button type='submit' onClick={() => { setshowerror(true) }} className='button-primary w-30 my-3  py-2 px-70'>Submit</Button>
                    </Box>

                </Box>
            </form>
            {loading && <Loading />}

        </Box>)

}
export default Applicationform2;